module.exports = __webpack_public_path__ + "static/candiaturespontanee-1b7cf5d70cd2801dddf0dd5d2d0acf0b.jpg";